import React from 'react';
import {
  Flex, Text, Icon, Box, Badge, Button, Heading,
  SimpleGrid, Table, Thead, Tbody, Tr, Th, Td,
  Spinner, Divider, useColorModeValue, Progress,
} from '@chakra-ui/react';
import {
  MdBuild, MdChevronRight, MdHourglassEmpty, MdAddCircle,
  MdAssignment, MdCheckCircle, MdLock,
} from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import Card from 'components/card/Card.js';
import { useMinhasOS } from '../hooks/useMinhasOS';

const STATUS_COLORS = {
  rascunho:             'gray',
  enviada:              'blue',
  aguardando_validacao: 'orange',
  aprovada:             'green',
  reprovada:            'red',
};
const STATUS_LABELS = {
  rascunho:             'Rascunho',
  enviada:              'Enviada',
  aguardando_validacao: 'Ag. Validação',
  aprovada:             'Aprovada',
  reprovada:            'Reprovada',
};

const STATUS_BORDER = {
  rascunho:             'gray.300',
  enviada:              'blue.400',
  aguardando_validacao: 'orange.400',
  aprovada:             'green.400',
  reprovada:            'red.400',
};

export default function MinhasOS() {
  const { ordens, loading } = useMinhasOS();
  const navigate     = useNavigate();
  const textColor    = useColorModeValue('navy.700', 'white');
  const subText      = useColorModeValue('gray.500', 'gray.400');
  const borderColor  = useColorModeValue('gray.100', 'gray.600');
  const rowHoverBg   = useColorModeValue('blue.50', 'whiteAlpha.50');
  const cardBg       = useColorModeValue('white', 'navy.800');
  const theadBg      = useColorModeValue('gray.50', 'navy.900');
  const statIconBg   = useColorModeValue('blue.50', 'whiteAlpha.100');
  const progressBg   = useColorModeValue('gray.100', 'whiteAlpha.100');

  const abertas    = ordens.filter((o) => ['rascunho', 'enviada'].includes(o.status));
  const emValidac  = ordens.filter((o) => o.status === 'aguardando_validacao');
  const concluidas = ordens.filter((o) => o.status === 'aprovada');

  const STATS = [
    {
      label: 'Em aberto',
      value: abertas.length,
      color: 'blue.500',
      iconBg: 'blue.50',
      iconColor: 'blue.500',
      icon: MdAssignment,
      progress: ordens.length > 0 ? (abertas.length / ordens.length) * 100 : 0,
      progressScheme: 'blue',
    },
    {
      label: 'Ag. validação',
      value: emValidac.length,
      color: 'orange.500',
      iconBg: 'orange.50',
      iconColor: 'orange.500',
      icon: MdHourglassEmpty,
      progress: ordens.length > 0 ? (emValidac.length / ordens.length) * 100 : 0,
      progressScheme: 'orange',
    },
    {
      label: 'Aprovadas',
      value: concluidas.length,
      color: 'green.500',
      iconBg: 'green.50',
      iconColor: 'green.500',
      icon: MdCheckCircle,
      progress: ordens.length > 0 ? (concluidas.length / ordens.length) * 100 : 0,
      progressScheme: 'green',
    },
  ];

  return (
    <Flex direction="column" pt={{ base: '8px', md: '16px', xl: '0px' }}>
      {/* â”€â”€ CabeÃ§alho â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      {/* Cabecalho */}
      <Card bg={cardBg} p={{ base: '12px 14px', md: '16px 20px', xl: '20px 24px' }} mb={{ base: '12px', md: '16px' }}>
        <Flex align="center" justify="space-between" gap="8px" wrap="wrap">
          <Flex align="center" gap={{ base: '8px', md: '12px' }} flex="1" minW={0}>
            <Icon as={MdBuild} boxSize={{ base: '22px', md: '28px' }} color="brand.500" flexShrink={0} />
            <Box minW={0}>
              <Heading size="md" color={textColor} noOfLines={1}>Minhas OS</Heading>
              <Text fontSize={{ base: '11px', md: 'sm' }} color={subText}>
                {ordens.length} {ordens.length === 1 ? 'ordem registrada' : 'ordens registradas'}
              </Text>
            </Box>
          </Flex>
          <Button
            leftIcon={<Icon as={MdAddCircle} boxSize="16px" />}
            colorScheme="brand"
            borderRadius="10px"
            size="sm"
            h={{ base: '36px', md: '40px' }}
            px={{ base: '12px', md: '16px' }}
            fontSize={{ base: '12px', md: 'sm' }}
            fontWeight="700"
            flexShrink={0}
            onClick={() => navigate('/admin/tecnico/registrar')}
          >
            Nova OS
          </Button>
        </Flex>
      </Card>

      {/* â”€â”€ Cards de resumo â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      {/* Cards de resumo */}
      <SimpleGrid columns={3} spacing={{ base: '6px', md: '12px', xl: '16px' }} mb={{ base: '14px', md: '20px' }}>
        {STATS.map(({ label, value, color, iconBg, iconColor, icon, progress, progressScheme }) => (
          <Card key={label} bg={cardBg} p={{ base: '10px 8px', md: '16px', xl: '20px' }} overflow="hidden">
            {/* Icone */}
            <Flex
              w={{ base: '28px', md: '40px' }}
              h={{ base: '28px', md: '40px' }}
              borderRadius={{ base: '7px', md: '12px' }}
              bg={iconBg}
              _dark={{ bg: 'whiteAlpha.100' }}
              align="center"
              justify="center"
              mx="auto"
              mb={{ base: '5px', md: '8px' }}
            >
              <Icon as={icon} boxSize={{ base: '14px', md: '20px' }} color={iconColor} _dark={{ color }} />
            </Flex>
            {/* Numero */}
            <Text
              fontSize={{ base: '18px', md: '28px' }}
              fontWeight="900"
              color={color}
              lineHeight="1"
              textAlign="center"
            >
              {value}
            </Text>
            {/* Label */}
            <Text
              fontSize={{ base: '8px', md: '11px' }}
              color={subText}
              mt="2px"
              fontWeight="600"
              noOfLines={1}
              textAlign="center"
            >
              {label}
            </Text>
            <Progress
              mt={{ base: '6px', md: '8px' }}
              value={progress}
              size="xs"
              colorScheme={progressScheme}
              borderRadius="full"
              bg={progressBg}
            />
          </Card>
        ))}
      </SimpleGrid>

      {/* â”€â”€ Lista/Tabela de OS â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      <Card bg={cardBg} p={0} overflow="hidden">
        {/* Header do card */}
        <Flex
          px={{ base: '16px', md: '24px' }}
          py={{ base: '14px', md: '18px' }}
          borderBottom="1px solid"
          borderColor={borderColor}
          align="center"
          justify="space-between"
        >
          <Text fontWeight="700" fontSize="sm" color={textColor} textTransform="uppercase" letterSpacing="wide">
            Histórico de ordens
          </Text>
          {loading && <Spinner size="sm" color="brand.500" />}
        </Flex>

        {loading ? (
          <Flex justify="center" py="60px">
            <Spinner size="lg" color="brand.500" />
          </Flex>
        ) : ordens.length === 0 ? (
          <Flex direction="column" align="center" py="60px" gap="12px" px="24px">
            <Flex
              w="72px" h="72px" borderRadius="full" bg={statIconBg}
              align="center" justify="center"
            >
              <Icon as={MdHourglassEmpty} boxSize="36px" color="brand.300" />
            </Flex>
            <Box textAlign="center">
              <Text fontWeight="700" color={textColor} fontSize="md">Nenhuma OS criada ainda</Text>
              <Text color={subText} fontSize="sm" mt="4px">
                Crie sua primeira ordem de serviço para começar.
              </Text>
            </Box>
            <Button
              colorScheme="brand" borderRadius="12px" h="44px" px="24px"
              leftIcon={<Icon as={MdAddCircle} />}
              onClick={() => navigate('/admin/tecnico/registrar')}
            >
              Criar primeira OS
            </Button>
          </Flex>
        ) : (
          <>
            {/* â”€â”€ MOBILE: lista de cards â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
            <Box display={{ base: 'block', md: 'none' }}>
              {ordens.map((os, idx) => (
                <Box key={os.id}>
                  <Flex
                    px="16px"
                    py="16px"
                    cursor="pointer"
                    align="center"
                    gap="12px"
                    _hover={{ bg: rowHoverBg }}
                    onClick={() => navigate(`/admin/tecnico/registrar?id=${os.id}`)}
                    minH="72px"
                  >
                    {/* Borda colorida de status */}
                    <Box
                      w="4px"
                      alignSelf="stretch"
                      borderRadius="full"
                      flexShrink={0}
                      bg={STATUS_BORDER[os.status] || 'gray.300'}
                    />

                    {/* Icone */}
                    <Flex
                      w="44px" h="44px" borderRadius="12px"
                      bg="brand.50" flexShrink={0}
                      align="center" justify="center"
                      _dark={{ bg: 'whiteAlpha.100' }}
                    >
                      <Icon as={MdBuild} color="brand.500" boxSize="20px" />
                    </Flex>

                    {/* Conteudo */}
                    <Box flex={1} minW={0}>
                      <Flex justify="space-between" align="flex-start" gap="8px">
                        <Box flex={1} minW={0}>
                          <Text fontSize="sm" fontWeight="700" color={textColor}
                            fontFamily="mono" isTruncated>
                          {os.numeroOS || os.protocolo || '—'}
                          </Text>
                          <Text fontSize="xs" color={subText} mt="2px" isTruncated>
                            {os.tipoServico || 'Tipo não definido'}
                          </Text>
                        </Box>
                        <Badge
                          colorScheme={STATUS_COLORS[os.status] || 'gray'}
                          borderRadius="full" px="8px" py="3px" fontSize="10px"
                          textTransform="none" flexShrink={0}
                        >
                          {STATUS_LABELS[os.status] || os.status}
                        </Badge>
                      </Flex>
                      <Text fontSize="xs" color={subText} mt="4px">
                        {os.criadaEm?.toDate
                          ? os.criadaEm.toDate().toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' })
                          : '—'}
                        {os.hora ? ` às ${os.hora}` : ''}
                      </Text>
                    </Box>

                    <Icon as={os.status === 'aprovada' ? MdLock : MdChevronRight}
                      color={os.status === 'aprovada' ? 'green.400' : 'gray.300'}
                      boxSize="22px" flexShrink={0} />
                  </Flex>
                  {idx < ordens.length - 1 && <Divider borderColor={borderColor} />}
                </Box>
              ))}
            </Box>

            {/* â”€â”€ DESKTOP: tabela â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
            <Box display={{ base: 'none', md: 'block' }} overflowX="auto">
              <Table variant="simple">
                <Thead bg={theadBg}>
                  <Tr>
                    <Th color={subText} fontSize="11px" py="14px" ps="24px" pe="8px">
                      Data / Hora
                    </Th>
                    <Th color={subText} fontSize="11px" py="14px" px="8px">Nº OS / Protocolo</Th>
                    <Th color={subText} fontSize="11px" py="14px" px="8px">Tipo de Serviço</Th>
                    <Th color={subText} fontSize="11px" py="14px" px="8px">Status</Th>
                    <Th py="14px" pe="24px" ps="8px" w="40px" />
                  </Tr>
                </Thead>
                <Tbody>
                  {ordens.map((os) => (
                    <Tr
                      key={os.id}
                      cursor="pointer"
                      borderBottom="1px solid"
                      borderColor={borderColor}
                      _hover={{ bg: rowHoverBg }}
                      onClick={() => navigate(`/admin/tecnico/registrar?id=${os.id}`)}
                    >
                      <Td ps="24px" pe="8px" py="16px" borderColor={borderColor}>
                        <Text fontSize="sm" fontWeight="600" color={textColor}>
                          {os.criadaEm?.toDate
                            ? os.criadaEm.toDate().toLocaleDateString('pt-BR')
                            : '—'}
                        </Text>
                        {os.hora && <Text fontSize="xs" color={subText} mt="1px">{os.hora}</Text>}
                      </Td>
                      <Td px="8px" py="16px" borderColor={borderColor}>
                        <Text fontSize="sm" color={textColor} fontFamily="mono" fontWeight="600">
                          {os.numeroOS || os.protocolo || '—'}
                        </Text>
                      </Td>
                      <Td px="8px" py="16px" borderColor={borderColor}>
                        <Text fontSize="sm" color={textColor}>{os.tipoServico || '—'}</Text>
                      </Td>
                      <Td px="8px" py="16px" borderColor={borderColor}>
                        <Badge
                          colorScheme={STATUS_COLORS[os.status] || 'gray'}
                          borderRadius="full" px="10px" py="3px" fontSize="xs"
                          textTransform="none"
                        >
                          {STATUS_LABELS[os.status] || os.status}
                        </Badge>
                      </Td>
                      <Td pe="24px" ps="8px" py="16px" borderColor={borderColor}>
                        <Icon as={os.status === 'aprovada' ? MdLock : MdChevronRight}
                        color={os.status === 'aprovada' ? 'green.400' : 'gray.300'}
                        boxSize="18px" />
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </Box>
          </>
        )}
      </Card>
    </Flex>
  );
}
